import React from 'react'

import { FormikCheckbox } from '../../components/FormikFields/FormikCheckbox/FormikCheckbox.styled'
import {
    CheckContainer,
    ResidenceParagraph,
    ErrorMessage,
} from './MarineWriteIn.styled'

interface QueryProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: any
    prefilled?: boolean
}

const disclosureMarineMessageCheckboxLabel = (
    <ResidenceParagraph>
        Marine financing not available for sailboats, high performance vessels,
        or houseboats. Additionally, financing FEMA units, salvaged units, or
        water damaged units is prohibited
    </ResidenceParagraph>
)

export default function DisclosureMarineMessageCheckbox({
    formik,
    prefilled,
}: QueryProps) {
    const touched = formik.touched.marine?.disclosureMessage
    const error = formik.errors.marine?.disclosureMessage
    const value = formik.values.marine?.disclosureMessage
    const formValue = 'marine.disclosureMessage'
    const displayError = !!(touched && error)

    return (
        <>
            <CheckContainer>
                <FormikCheckbox
                    disabled={false}
                    prefilled={prefilled}
                    error={displayError}
                    id={formValue}
                    label=""
                    value={formValue}
                    checked={value}
                    onChange={(val) => {
                        const event = {
                            target: {
                                name: formValue,
                                value: val,
                            },
                        }

                        formik.handleChange(event)
                    }}
                />
                <label htmlFor={formValue}>
                    {disclosureMarineMessageCheckboxLabel}
                </label>
            </CheckContainer>
            {displayError && <ErrorMessage>The field is required</ErrorMessage>}
        </>
    )
}
